import { IGetEmpreendimentoDropDownUseCase } from "../../../presentation/useCases/read/get_empreendimento_drop_down_use_case";
import { EmpreendimentoDropDown } from "../../models/empreendimento";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetEmpreendimentoDropDownUseCase
 */

export class GetEmpreendimentoDropDownUseCase implements IGetEmpreendimentoDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getEmpreendimentoDropdown(): Promise<EmpreendimentoDropDown[]> {
    return await this.repository.getEmpreendimentoDropdown();
  }
}
